module.exports = __webpack_public_path__ + "img/tada.31d366ff.png";